import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from '@angular/core';
import { NotificationRow } from '../notifications.models';
import { WebPushState } from '../web-push.models';

export interface NotificationPanelState {
  rows: readonly NotificationRow[];
  loading: boolean;
  hasError: boolean;
  unreadCount: number;
  canMarkAll: boolean;
  push: WebPushState;
  pushPending: boolean;
}

/**
 * Every control is a mat-menu-item, because Tab closes a mat-menu and arrow keys only travel between menu
 * items. That is also why mark-all sits in the footer: from the header, one press of Down would land a
 * keyboard user on a bulk mutation instead of on their newest notification.
 */
@Component({
  selector: 'app-knowledge-notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
  // The panel is detached from this subtree, so only unencapsulated rules reach it. Every selector in the
  // stylesheet is nested under .notification-panel to keep the leak namespaced.
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotificationPanelComponent {
  public readonly state = input.required<NotificationPanelState>();

  public readonly activated = output<NotificationRow>();
  public readonly markAllRequested = output<void>();
  public readonly retryRequested = output<void>();
  public readonly pushToggled = output<void>();
}
